import { gql } from '@apollo/client'

export const FIND_MANY_CUSTOMER_SUB_ACCOUNT = gql`
  query FindManyCustomerSubAccount($customerId: Int!) {
    findManyCustomerSubAccount(where: { customerId: { equals: $customerId } }) {
      id
      createdAt
      updatedAt
      name
      customerId
      _count {
        customerAccounts
      }
    }
  }
`

export const FIND_UNIQUE_CUSTOMER_SUB_ACCOUNT = gql`
  query FindUniqueCustomerSubAccount($id: Int!) {
    findUniqueCustomerSubAccount(where: { id: $id }) {
      id
      createdAt
      updatedAt
      name
      customerId
      _count {
        customerAccounts
      }
    }
  }
`

export const CREATE_ONE_CUSTOMER_SUB_ACCOUNT = gql`
  mutation CreateOneCustomerSubAccount($customerId: Int!, $name: String!) {
    createOneCustomerSubAccount(
      data: { customer: { connect: { id: $customerId } }, name: $name }
    ) {
      id
      createdAt
      updatedAt
      name
      customerId
      _count {
        customerAccounts
      }
    }
  }
`

export const UPDATE_ONE_CUSTOMER_SUB_ACCOUNT = gql`
  mutation UpdateOneCustomerSubAccount(
    $where: CustomerSubAccountWhereUniqueInput!
    $data: CustomerSubAccountUpdateInput!
  ) {
    updateOneCustomerSubAccount(where: $where, data: $data) {
      id
      createdAt
      updatedAt
      name
      customerId
      _count {
        customerAccounts
      }
    }
  }
`

export const DELETE_ONE_CUSTOMER_SUB_ACCOUNT = gql`
  mutation DeleteOneCustomerSubAccount($id: Int!) {
    deleteOneCustomerSubAccount(where: { id: $id }) {
      id
    }
  }
`
